import { PlusIcon } from '../../../../assets/icons/index';
import Button from '../../../../components/button/index';
import {
  EmptyState as EmptyStateBase,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../../components/empty-state/index';
import { formStore } from '../form/form.store';

export const GeneralEmptyState = () => {
  const openCreate = formStore(({ openCreate }) => openCreate);

  return (
    <EmptyStateBase
      colorScheme={EmptyStateVariant.BEIGE}
      description={'When available, perks will be displayed here'}
      imageVariant={EmptyStateImageVariant.CLIPBOARD}
      text="No Perks Found"
    >
      <Button className="flex h-9 gap-2 text-nowrap px-4 py-2" onClick={openCreate}>
        <PlusIcon />
        Create Perk
      </Button>
    </EmptyStateBase>
  );
};
